import { Layout, Space, Card, Row, Col, PageHeader } from "antd";
import Markdown from "react-markdown";
import { src } from "../../helpers/docs";

export function Docs() {
  return (
    <Layout className="content">
      <Layout.Header className="content-header">
        <Row>
          <Col span={16}>
            <PageHeader title="Documentation" className="page-title" />
          </Col>
        </Row>
      </Layout.Header>
      <Layout.Content className="content-body">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
          size={40}
        >
          <Card className={"card-body"}>
            <Markdown children={src} />
          </Card>
        </Space>
      </Layout.Content>
    </Layout>
  );
}
